import { Button$PressEvent } from "sap/m/Button";
import List from "../List";
import ColumnMenuUtils from "./ColumnMenuUtils";
import Control from "sap/ui/core/Control";
export default class ListUtils {
	public static buildColumnMenus(list: List): void {
		const columns = list.getTable().getColumns();
		columns.forEach((column) => {
			const filterProperty = column.getFilterProperty();
			if (!filterProperty) return;
			// Delegate column menu logic to ColumnMenuUtils
			ColumnMenuUtils.loadColumnMenu(list, column, filterProperty);
		});
	}

	public static onRemoveFilter(event: Button$PressEvent): void {
		const button = event.getSource();
		let parent = button.getParent() as Control;
		let maxDepth = 10; // Prevent infinite loops
		while (parent && !parent.data("list")) {
			parent = parent.getParent() as Control;
			if (maxDepth-- <= 0) {
				console.error("Max depth reached while searching for List control.");
				return;
			}
		}
		const list = parent.data("list") as List;
		const colName = button.data("field") as string;
		const column = list
			.getTable()
			.getColumns()
			.find((col) => col.getFilterProperty() === colName);
		if (column) {
			list.removeColumnFilter(column);
		} else {
			console.warn("Column not found for button:", button.getId());
		}
	}
}
